// import React, { useState } from "react";
// import axios from "axios";
// import { message, Rate } from "antd";
// import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate for navigation


// const Feedback = () => {
//   const userExist = localStorage.getItem("auth");

//   // eslint-disable-next-line no-unused-vars
//   const userData = userExist ? JSON.parse(userExist) : null;
//   const navigate = useNavigate(); // Initialize useNavigate hook
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const orderId = queryParams.get("orderId");

//   const [feedbackData, setFeedbackData] = useState({
//     totalCharges: "",
//     rating: 0,
//     feedback: "",
//   });

//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFeedbackData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleRatingChange = (value) => {
//     setFeedbackData((prevData) => ({
//       ...prevData,
//       rating: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!feedbackData.totalCharges || !feedbackData.feedback || feedbackData.rating === 0) {
//       message.error("All fields are required.");
//       return;
//     }

//     setLoading(true);

//     try {
//       const authData = localStorage.getItem("auth");
//       const authObject = authData ? JSON.parse(authData) : {};
//       const token = authObject?.accessToken;

//       const response = await axios.post(
//         `${API_BASE}/feedback`,
//         {
//           ...feedbackData,
//           orderId, // <-- include this in request
//         },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       console.log("API Response:", response);

//       if (response.data.success) {
//         message.destroy();
//         message.success("Feedback updated successfully!");
//         setFeedbackData({
//           totalCharges: "",
//           rating: 0,
//           feedback: "",
//         });
//         navigate("/"); // Navigate after success
//       } else {
//         message.destroy();
//         message.error(response.data.message || "Failed to update feedback.");
//       }
//     } catch (error) {
//       console.error("Error updating feedback:", error);

//       if (error.response) {
//         const { data } = error.response;
//         message.error(data.message || "Something went wrong. Please try again.");
//       } else {
//         message.error("Network error. Please try again.");
//       }
//     } finally {
//       setLoading(false); // Ensure loading is reset
//     }
//   };
// const API_BASE = process.env.REACT_APP_API_BASE;

//   return (
//     <div
//       className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
//       style={{
//         backgroundImage:
//           "url('https://images.unsplash.com/photo-1579548122080-c35fd6820ecb?fm=jpg&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Ymx1ZSUyMHRlY2h8ZW58MHx8MHx8fDA%3D&ixlib=rb-4.1.0&q=60&w=3000')",
//       }}
//     >
//       <div className="max-w-lg w-full bg-white bg-opacity-95 p-5 rounded-md shadow-md border border-gray-300">
//         <h2 className="text-center text-xl mb-4 text-gray-800">Customer Feedback</h2>
//         {orderId && (
//           <p className="text-sm text-gray-600 mb-4 ">
//             <strong>Order ID:</strong> {orderId}
//           </p>
//         )}
//         <form onSubmit={handleSubmit}>
//           {/* Total Charges */}
//           <div className="mb-3">
//             <label className="block text-gray-700 text-sm mb-1">Total Charges</label>
//             <input
//               type="number"
//               name="totalCharges"
//               value={feedbackData.totalCharges}
//               onChange={handleChange}
//               className="w-full px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
//               placeholder="Enter total charges paid"
//             />
//           </div>

//           {/* Star Rating */}
//           <div className="mb-3">
//             <label className="block text-gray-700 text-sm mb-1">Star Rating</label>
//             <Rate
//               value={feedbackData.rating}
//               onChange={handleRatingChange}
//               allowClear
//             />
//           </div>

//           {/* Feedback Text */}
//           <div className="mb-3">
//             <label className="block text-gray-700 text-sm mb-1">Feedback</label>
//             <textarea
//               name="feedback"
//               value={feedbackData.feedback}
//               onChange={handleChange}
//               className="w-full px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
//               placeholder="Share your thoughts on the service"
//               rows="3"
//             ></textarea>
//           </div>

//           {/* Submit Button */}
//           <button
//             type="submit"
//             className={`w-full py-2 rounded-md text-white ${loading ? 'bg-gray-400' : 'bg-red-500'} hover:bg-red-600`}
//             disabled={loading}
//           >
//             {loading ? 'Submitting...' : 'Submit Feedback'}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Feedback;
import React, { useState } from "react";
import axios from "axios";
import { message, Rate } from "antd";
import { useNavigate, useLocation } from "react-router-dom"; 
import { Link } from 'react-router-dom';

// Global constant
const API_BASE = process.env.REACT_APP_API_BASE;

const Feedback = () => {
  // Check for user existence and token retrieval
  let authObject = null;
  try {
    const authData = localStorage.getItem("auth");
    if (authData) {
      authObject = JSON.parse(authData);
    }
  } catch (error) {
    console.error("Error parsing auth data from localStorage:", error);
  }
  const token = authObject?.accessToken;

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("orderId");

  const [feedbackData, setFeedbackData] = useState({
    totalCharges: "",
    rating: 0,
    feedback: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFeedbackData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRatingChange = (value) => {
    setFeedbackData((prevData) => ({
      ...prevData,
      rating: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      message.error("You must be logged in to submit feedback.");
      return;
    }
    if (!orderId) {
        message.error("Order ID is missing. Cannot submit feedback without it.");
        return;
    }
    if (!feedbackData.totalCharges || !feedbackData.feedback || feedbackData.rating === 0) {
      message.error("All fields (Charges, Rating, Feedback) are required.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE}/feedback`,
        {
          ...feedbackData,
          totalCharges: parseFloat(feedbackData.totalCharges), // Ensure charges is a number
          orderId, 
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        message.success("Feedback submitted successfully! Thank you.");
        // Reset form after success
        setFeedbackData({
          totalCharges: "",
          rating: 0,
          feedback: "",
        });
        
        // Navigate after success
        setTimeout(() => navigate("/orderhistory"), 1500); 

      } else {
        message.error(response.data.message || "Failed to submit feedback.");
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      const errorMessage = error.response?.data?.message || "Network error. Please try again.";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
    
  const InputField = ({ label, name, type = "text", value, onChange, placeholder, disabled }) => (
    <div>
      <label className="block text-gray-700 text-sm mb-1">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100"
        placeholder={placeholder}
        required
      />
    </div>
  );


  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center px-4"
      style={{
        backgroundImage:
          // MF Blind style background
          "url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1950&q=80')",
      }}
    >
      <div className="max-w-lg w-full bg-white bg-opacity-95 p-8 rounded-lg shadow-2xl border border-gray-200">
        
        {/* MF Blind-style Header */}
        <div className="mb-6 border-b pb-4 text-center">
            <h1 className="text-xl font-bold text-green-700">MF Blind</h1>
            <h2 className="text-2xl mt-2 text-gray-800">Service Feedback</h2>
        </div>
        
        {orderId ? (
          <p className="text-center text-sm text-gray-600 mb-6 font-semibold bg-green-50 p-2 rounded-md">
            Providing feedback for Order ID: <span className="text-green-700">{orderId}</span>
          </p>
        ) : (
            <p className="text-center text-sm text-red-500 mb-6 font-semibold bg-red-50 p-2 rounded-md">
                Error: Order ID is missing from the URL.
            </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Total Charges */}
          <InputField
                label="Total Charges Paid (in USD)"
                type="number"
                name="totalCharges"
                value={feedbackData.totalCharges}
                onChange={handleChange}
                placeholder="e.g., 50.00"
                disabled={loading}
            />

          {/* Star Rating */}
          <div className="pt-2">
            <label className="block text-gray-700 text-sm mb-2">Service Quality Rating</label>
            <Rate
              value={feedbackData.rating}
              onChange={handleRatingChange}
              allowClear
              className="text-2xl text-yellow-500"
              disabled={loading}
            />
            <span className="ml-4 text-sm text-gray-500">
                {feedbackData.rating === 0 ? "Not Rated" : `${feedbackData.rating} out of 5 stars`}
            </span>
          </div>

          {/* Feedback Text */}
          <div>
            <label className="block text-gray-700 text-sm mb-1">Detailed Feedback</label>
            <textarea
              name="feedback"
              value={feedbackData.feedback}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100"
              placeholder="Share your thoughts on the service, what was good, and what could be improved."
              rows="4"
              disabled={loading}
            ></textarea>
          </div>

          {/* Submit Button (MF Blind Green Style) */}
          <button
            type="submit"
            className={`w-full py-3 mt-6 rounded-md text-white font-semibold transition duration-150 shadow-md ${
                loading || !token || !orderId ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-700 hover:bg-green-800'
            }`}
            disabled={loading || !token || !orderId}
          >
            {loading ? 'Submitting Feedback...' : 'Submit Feedback'}
          </button>
          
          <div className="text-center mt-4">
            <Link to="/orderhistory" className="text-sm text-green-700 hover:text-green-900 font-medium">
                <span className="border-b border-green-700 border-opacity-50 pb-0.5">
                    Go Back to Order History
                </span>
            </Link>
          </div>

        </form>
      </div>
    </div>
  );
};

export default Feedback;